export default (...wrappers) => ({ element: rootElement }) =>
  [...wrappers].reduce((element, wrapper) => wrapper({ element }), rootElement);
